import { actions } from '..';
import * as api from '../../api';
import { selectMyself } from '../reducers/config';
import { shouldFetchVoiceMail } from '../reducers/voiceMail';
import { all } from 'async-saga';
import { takeEvery, waitForState, wireUpApi } from '../tools/async-saga-types';

const fetchVoiceMail = wireUpApi(actions.fetchVoiceMail, (state, payload) => shouldFetchVoiceMail(state, payload.mailbox, payload.folder))
const onRequestSaveVoiceMail = takeEvery(actions.requestSaveVoiceMail, async (ctx, { mailbox, id, folder }) => {
  api.saveVoiceMail(mailbox, id, folder)
})

const onRequestdeleteVoiceMail = takeEvery(actions.requestDeleteVoiceMail, async (ctx, { mailbox, id, folder }) => {
  api.deleteVoiceMail(mailbox, id, folder)
})

const onRequestSaveVoiceMails = takeEvery(actions.requestSaveVoiceMails, async (ctx, { mailbox, ids, folder }) => {
  api.saveVoiceMails(mailbox, ids, folder)
})

const onRequestDeleteVoiceMails = takeEvery(actions.requestDeleteVoiceMails, async (ctx, { mailbox, ids, folder }) => {
  api.deleteVoiceMails(mailbox, ids, folder)
})

const fetchUnreadVmCount = takeEvery(actions.fetchUnreadVoiceMailCount, async ctx => {
  try {
    const me = await waitForState(ctx, selectMyself)
    const unread = await api.getUnreadVoiceMailCount(me)
    ctx.dispatch(actions.updateVmUnreadCount(me, unread))

  } catch (e) {
    api.processApiError(e, ctx.dispatch)
  }
})

export default all(
  fetchUnreadVmCount,
  fetchVoiceMail,
  onRequestSaveVoiceMail,
  onRequestdeleteVoiceMail,
  onRequestSaveVoiceMails,
  onRequestDeleteVoiceMails,
)
